import { render } from "./GROUPS.vue?vue&type=template&id=431ebfaf&scoped=true"
import script from "./GROUPS.vue?vue&type=script&lang=js"
export * from "./GROUPS.vue?vue&type=script&lang=js"

import "./GROUPS.vue?vue&type=style&index=0&id=431ebfaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431ebfaf"]])

export default __exports__